var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "modal": _vm.detail && _vm.detail.type == 'compose' ? _vm.isNftUrlLLoad : true,
      "showClose": _vm.detail && _vm.detail.type == 'compose' ? _vm.animateEle : true,
      "height": "auto",
      "width": "70%"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_vm.detail ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detail.type == 'compose' ? _vm.isNftUrlLLoad : true,
      expression: "detail.type == 'compose' ? isNftUrlLLoad : true"
    }],
    key: _vm.detail?.image_url,
    staticClass: "popNftDetail",
    class: {
      'animate-start': _vm.detail.type == 'compose' ? _vm.animateStart : false,
      imgResult: _vm.animateEle
    }
  }, [_c('div', {
    ref: "imgRef",
    staticClass: "popNftDetail-img",
    class: _vm.detail.type == 'compose' && 'initAnim'
  }, [_c('img', {
    attrs: {
      "src": _vm.detail.image_url,
      "alt": ""
    },
    on: {
      "load": _vm.onImageLoad,
      "error": _vm.onImageError
    }
  })]), _c('transition', {
    attrs: {
      "name": "fadeele-slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detail.type == 'compose' ? _vm.showEle : true,
      expression: "detail.type == 'compose' ? showEle : true"
    }],
    staticClass: "popNftDetail-ele",
    class: [_vm.detail.type == 'compose' && 'initAnim', {
      'animate-ele': _vm.detail.type == 'compose' ? _vm.animateEle : false
    }]
  }, [_c('div', {
    staticClass: "popNftDetail-ele__name"
  }, [_vm._v(_vm._s(_vm.detail.name))]), _c('div', {
    staticClass: "popNftDetail-ele-main"
  }, [_vm._l(_vm.detail.attributes, function (val, key, index) {
    return _c('div', {
      key: index,
      staticClass: "popNftDetail-ele-item",
      class: _vm.detail.type == 'compose' && 'initAnim',
      style: {
        transitionDelay: _vm.animateEle ? `${index * 0.1}s` : '0s'
      }
    }, [_c('div', {
      staticClass: "popNftDetail-ele-item__attr"
    }, [_vm._v(" " + _vm._s(key) + ":  " + _vm._s(val.value) + " ")]), _c('div', {
      staticClass: "popNftDetail-ele-item__rarity"
    }, [_vm._v(_vm._s(val.rarity) + "%")])]);
  }), _c('div', {
    staticClass: "btn-mint"
  }, [_vm._v("Mint")])], 2)])])], 1)] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };